import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}

export default function Card({ 
  children, 
  className = '',
  hoverEffect = true
}: CardProps) {
  return (
    <motion.div 
      className={`bg-white rounded-2xl shadow-soft p-6 ${className}`}
      whileHover={hoverEffect ? { 
        y: -5, 
        boxShadow: '0 10px 40px -3px rgba(0, 0, 0, 0.1), 0 10px 20px -2px rgba(0, 0, 0, 0.04)' 
      } : {}}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
}
